var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mainSection"},[_c('h1',[_vm._v("Portfolio")]),_vm._l((_vm.items),function(item){return [_c('router-link',{key:item.id_num,attrs:{"to":item.url_title}},[_c('p',[_vm._v(_vm._s(item.title))])])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }